import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-[45vh] flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50"
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">
            <strong>香港專業工程服務 - 村屋僭建物申報專家</strong>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-gray-700">
            焯峯工程有限公司專業提供<strong>村屋僭建物申報</strong>、<strong>TCP T1</strong>、<strong>TCP T3</strong>、<strong>BD T1</strong>、<strong>BD T3</strong>、<strong>RSE T3</strong>及<strong>國內T1適任技術人員註冊服務</strong>，確保您的工程項目符合屋宇署監督制度要求
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/85291898819"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              立即諮詢
            </a>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
              href="#services"
            >
              了解服務
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
